module.exports = __webpack_public_path__ + "static/media/chess-king.3c8e69fe.svg";